// extracted by mini-css-extract-plugin
module.exports = {"hero":"index-module--hero--3F2DU","avatar":"index-module--avatar--3dD9_","avatar__image":"index-module--avatar__image--1RBQl","avatar__link":"index-module--avatar__link--30IpW"};